import * as signalR from '@microsoft/signalr';
import config from '@/config'

export default {
	// 开启命名空间
	namespaced:true,
	actions:{
    createConnection({state, commit}, userApiSercve) {
      let chatServerUrl = state.wsServerUrl;
      if (userApiSercve) {
        chatServerUrl = state.apiServerUrl;
      }
      console.log('连接:' + chatServerUrl);
    },
	},
	mutations:{
    addTalk(state, val) {
      state.talkList.push(val);
    },
	},
	state:{
    talkList: [],
    wsServerUrl: config.BASE_URL_WS,
    apiServerUrl: config.BASE_URL,
	},
	getters:{
 
	},
}